export const languageList = [
    { code: 'en', name: 'English' },
    { code: 'no', name: 'Norwegian' },
    { code: 'fr', name: 'French' },
    { code: 'sv', name: 'Swedish' }
];

export const pageSizeList = [
    { code: 10, name: 10 },
    { code: 20, name: 20 },
    { code: 30, name: 30 },
    { code: 50, name: 50 }
];
export const dateFormatList = [
    { code: 'dd/MM/yyyy', name: 'dd/MM/yyyy' },
    { code: 'yyyy-MM-dd', name: 'yyyy-MM-dd' },
    { code: 'dd.MM.yyyy', name: 'dd.MM.yyyy' },
    { code: 'M/dd/yyyy', name: 'M/dd/yyyy' }
];
export const timeFormatList = [
    { code: 'HH:mm', name: 'HH:mm' },
    { code: 'HH:mm:ss', name: 'HH:mm:ss' },
    { code: 'hh:mm:ss aaa', name: 'hh:mm:ss aaa' },
    { code: 'hh:mm aaa', name: 'hh:mm aaa' },
    { code: 'h:mm:ss aaa', name: 'h:mm:ss aaa' },
    { code: 'h:mm aaa', name: 'h:mm aaa' }
];

export const defaultNumberOfRecords = 20;
export const defaultLanguage = 'en';
export const defaultDateFormat = 'yyyy-MM-dd';
export const defaultTimeFormat = 'HH:mm';
